import {
  APP_SETTING_FETCH_JS_EDITOR_DATA_BEGIN,
  APP_SETTING_FETCH_JS_EDITOR_DATA_SUCCESS,
  APP_SETTING_FETCH_JS_EDITOR_DATA_FAILURE,
  APP_SETTING_FETCH_JS_EDITOR_DATA_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
export function fetchJsEditorData(args = {}) {
  const { url, uuid, customJsCdnData } = args;
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_FETCH_JS_EDITOR_DATA_BEGIN,
    });
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(url);
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_FETCH_JS_EDITOR_DATA_SUCCESS,
            data: res.data,
            jsuuid: uuid,
            customJsCdnData: customJsCdnData,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_FETCH_JS_EDITOR_DATA_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchJsEditorDataError() {
  return {
    type: APP_SETTING_FETCH_JS_EDITOR_DATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_FETCH_JS_EDITOR_DATA_BEGIN:
      return {
        ...state,
        fetchJsEditorDataPending: true,
        fetchJsEditorDataError: null,
      };

    case APP_SETTING_FETCH_JS_EDITOR_DATA_SUCCESS:
      return {
        ...state,
        fetchJsEditorDataPending: false,
        fetchJsEditorDataError: null,
        jsEditorValue: action.data,
        jsuuid: action.jsuuid,
        customJsCdnData: action.customJsCdnData,
        isOpenJsEditorModal: !state.isOpenJsEditorModal
          ? !state.isOpenJsEditorModal
          : state.isOpenJsEditorModal,
      };

    case APP_SETTING_FETCH_JS_EDITOR_DATA_FAILURE:
      return {
        ...state,
        fetchJsEditorDataPending: false,
        fetchJsEditorDataError: action.data.error,
      };

    case APP_SETTING_FETCH_JS_EDITOR_DATA_DISMISS_ERROR:
      return {
        ...state,
        fetchJsEditorDataError: null,
      };

    default:
      return state;
  }
}
